import script from "./SignupPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignupPage.vue?vue&type=script&setup=true&lang=ts"

import "./SignupPage.vue?vue&type=style&index=0&id=4a5ef870&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a5ef870"]])

export default __exports__